import React, { useContext } from "react";
import { useOutletContext } from "react-router-dom";

import ProductionDiscussionOld from "../../views/ProductionView/components/ProductionDiscussionOld";
import ProductionViewContext from "../../views/ProductionView/context/ProductionViewContext";

export default function ProductionDiscussions() {
	const { production } = useOutletContext();
	const { permissions } = useContext(ProductionViewContext);

	return <ProductionDiscussionOld production={production} permissions={permissions} />;
}
